const namespace = 'course';

export const INIT_COURSE_INFO = "initCourseInfo";
export const DISPATCH_INIT_COURSE_INFO = `${namespace}/${INIT_COURSE_INFO}`;
// 立即学习
export const LAST_STUDY_SECTION = "lastStudyCourse";
export const DISPATCH_LAST_STUDY_SECTION = `${namespace}/${LAST_STUDY_SECTION}`;
// 切换章节
export const SWITCH_SECTION = "switchSection";
export const DISPATCH_SWITCH_SECTION = `${namespace}/${SWITCH_SECTION}`;
// 收藏课程
export const COLLECT_COURSE = "collectCourse";
export const DISPATCH_COLLECT_COURSE = `${namespace}/${COLLECT_COURSE}`;
